module.exports = __webpack_public_path__ + "img/12b_asia.5dd1302e.png";